import { Button, Card, CardBody, useDisclosure } from '@heroui/react';
import { useAuth } from '@/hooks/auth';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmailLogin } from '@/components/login/email';

export default function Login() {
  const emailLogin = useDisclosure();

  const { login, authorized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authorized) {
      navigate('/');
    }
  }, [authorized, navigate]);

  if (authorized || authorized === undefined) {
    return <></>;
  }

  return (
    <div className='flex flex-col items-center justify-center pt-12'>
      <Card className='rounded-none'>
        <CardBody>
          <div className='mb-6 mt-6 flex flex-col items-center justify-around'>
            <div className='font-weight-bold text-small'>Welcome to</div>
            <div className='text-center text-large font-medium'>
              <img
                src='/ministryhub-black.svg?v=20260911'
                alt='Ministry Hub logo'
                width={200}
              />
            </div>
          </div>

          <Button
            size='lg'
            variant='ghost'
            startContent={
              <img
                src='/assets/google.svg?v=20260911'
                width={30}
                height={30}
                alt='Google logo'
              />
            }
            className='mx-8 my-4 mt-2'
            onPress={() => login()}
          >
            Login with Google
          </Button>

          <Button
            size='lg'
            variant='ghost'
            startContent={<Icon icon='mdi:email' width={32} />}
            className='mx-8 my-4 mt-2'
            onPress={emailLogin.onOpen}
          >
            Login with Email
          </Button>
          <EmailLogin disclosure={emailLogin} />
        </CardBody>
      </Card>
    </div>
  );
}
